import { ApiClient } from '@api/api-configuration';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

const queryKey = ['all-client-categories-limit-1000'];

const useGlobalClientCategories = () => {
  const queryClient = useQueryClient();

  const {
    data: res,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey,
    queryFn: async () => ApiClient.clientApi.clientCategories.listClientCategories({ limit: 1000, offset: 0 }),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const clientCategories = res?.data?.data ?? [];

  const invalidateGlobalClientCategories = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['all-client-categories-limit-1000'],
    });
  }, [queryClient]);

  return {
    globalClientCategories: clientCategories,
    totalCount: clientCategories.length,
    areGlobalClientCategoriesLoading: isLoading,
    areGlobalClientCategoriesFetching: isFetching,
    hasGlobalClientCategoriesError: isError,
    globalClientCategoriesError: error,
    invalidateGlobalClientCategories,
  };
};

export default useGlobalClientCategories;
